// extracted by mini-css-extract-plugin
export default {"counter":"_812c5ec2"};